import { FC } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import AuthCard from '../../components/AuthCard';

type PropTypes = RouteComponentProps;

const ConfirmationPage: FC<PropTypes> = () => (
  <AuthCard title="Senha alterada com sucesso!">
    <div className="p-col-12 p-text-center confirmation-content">
      <p className="confirmation-message">
        Sua senha foi alterada com sucesso!
      </p>
      <p className="confirmation-subtitle">
        Volte ao aplicativo Aqila e realize o login.
      </p>
    </div>
  </AuthCard>
);

export default ConfirmationPage;
